import { useContext } from 'react';
import { ExperienceTrackerContext } from '@atlassian/experience-tracker';

export const useExperienceContext = () => {
	const context = useContext(ExperienceTrackerContext);
	return context;
};
